import { IListSupportItem, IListSupportSection, SupportTileEnum } from "../types";

const catchallSectionItems = [
  {
    id: -1,
    title: "I have a different question for my veterinary care team.",
    body: "If your question relates to a prescription or medical information, please contact the clinic.",
    tiles: [
      { id: 1, kind: SupportTileEnum.ClinicPhone },
      { id: 2, kind: SupportTileEnum.ClinicSms },
      { id: 3, kind: SupportTileEnum.ClinicEmail },
    ],
  },
  {
    id: -2,
    title: "I have a different question specifically related to online ordering.",
    body: "If your question relates to an order delivery or a website issue, please contact Home Delivery Support via Email or Chat.",
    tiles: [
      { id: 1, kind: SupportTileEnum.VetcoveEmail },
      { id: 2, kind: SupportTileEnum.Chat },
    ],
  },
];

export const catchallSection: IListSupportSection = {
  id: 0,
  title: "I can't find the answer to my question...",
  items: catchallSectionItems,
};

export const catchallItems: IListSupportItem[] = catchallSectionItems.map((item) => ({
  id: item.id,
  title: item.title,
  support_section: {
    id: catchallSection.id,
    title: catchallSection.title,
  },
  body: item.body,
}));
